import { useState, useEffect } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { appHref } from '../tenant';

export function SessionExpiredDialog() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener('session-expired', handler);
    return () => window.removeEventListener('session-expired', handler);
  }, []);

  return (
    <Modal
      isOpen={show}
      onClose={() => {}}
      size="sm"
      closeOnOverlayClick={false}
      closeOnEscape={false}
      footer={
        <Button onClick={() => { window.location.href = appHref('/login'); }}>
          Log In
        </Button>
      }
    >
      <div style={{ textAlign: 'center', padding: '8px 0' }}>
        <h2 style={{ margin: '0 0 12px' }}>Session Expired</h2>
        <p style={{ margin: 0, color: 'var(--text-secondary, #666)' }}>
          Your session has expired. Please log in again.
        </p>
      </div>
    </Modal>
  );
}
